export enum LocalStorageConstants {
  locale = "locale",
}
